<template>
  <TransferStepCard :step="3" :title="t('whatsapp.transfer_confirmation')" @back="$emit('back')">
    <div class="flex justify-center">
      <div class="w-full max-w-5xl">
        <div class="">
          <TransferSummaryCards
            :contact-name="contactName"
            :contact-phone="contactPhone"
            :transfer-type="transferType"
            :destination-name="destinationName"
            :destination-subtitle="destinationSubtitle"
            :destination-meta="destinationMeta"
          />

          <div
            class="app-border-card-calss text-xs mt-6 rounded-lg shadow-sm px-4 py-3 text-sm text-[var(--p-primary-color)] dark:text-[var(--p-surface-300)]"
          >
            {{ transferNote }}
          </div>

          <div
            v-if="showMessageField"
            class="mt-6 border-t border-[var(--p-surface-200)] pt-5 dark:border-[var(--p-surface-700)]"
          >
            <label class="montserrat mb-2 block text-md font-medium text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]">
              {{ t('whatsapp.transfer_message_label') }}
            </label>
            <AppTextarea
              :model-value="message"
              :rows="4"
              auto-resize
              :maxlength="500"
              :placeholder="t('whatsapp.transfer_message_placeholder')"
              class="w-full !bg-transparent !text-sm"
              :disabled="messageDisabled"
              @update:model-value="$emit('update:message', $event)"
            />
            <div
              class=" text-right text-xs text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
            >
              {{ message.length }}/500
            </div>

            <!-- <div
              v-if="message.trim()"
              class="mt-4 rounded-xl border border-[var(--p-surface-200)] bg-[var(--p-surface-0)] p-4 dark:border-[var(--p-surface-700)] dark:bg-[var(--p-surface-950)]"
            >
              <span class="text-[var(--p-surface-500)] dark:text-[var(--p-surface-400)]"
                >{{ t('whatsapp.message') }}:</span
              >
              <p class="mb-0 mt-1 whitespace-pre-wrap dark:text-[var(--p-text-color)]">
                {{ message.trim() }}
              </p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </TransferStepCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Textarea from 'primevue/textarea'
import { useI18n } from 'vue-i18n'
import TransferStepCard from './TransferStepCard.vue'
import TransferSummaryCards from './TransferSummaryCards.vue'
import AppTextarea from '@/components/atoms/textarea/AppTextarea.vue'

interface Props {
  contactName: string
  contactPhone: string
  transferType: 'campaign' | 'user' | 'bot'
  destinationName: string
  destinationSubtitle?: string | null
  destinationMeta?: string | null
  showMessageField?: boolean
  message?: string
  messageDisabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  destinationSubtitle: null,
  destinationMeta: null,
  showMessageField: false,
  message: '',
  messageDisabled: true,
})

defineEmits<{
  'update:message': [value: string]
  back: []
}>()

const { t } = useI18n()

const transferNote = computed(() => {
  if (props.transferType === 'user') return t('whatsapp.transfer_note_user')
  if (props.transferType === 'campaign') return t('whatsapp.transfer_note_campaign')
  return t('whatsapp.transfer_note_bot')
})
</script>
